export default "__VITE_ASSET__bf108a1b__"